import React from 'react';
import { InView } from 'react-intersection-observer';

import useEventTracking from '@hooks/useEventTracking';
import { TI502026Props } from '@interfaces/ti50';
import { ContentType, ImpressionElement, Page, impression } from '@tracking';

import Paywall from '../Paywall';
import SEOContent from '../SEOContent';
import Header from './Header';

const Layout = ({
  activeCategories,
  data,
  isSEOBot,
  paywallData,
  project,
  tier,
}: TI502026Props) => {
  const { Track, trackEvent } = useEventTracking({
    contentId: project.id,
    contentType: ContentType.Project,
    page: Page.Project,
    pageId: project.id,
  });

  return (
    <Track>
      <InView
        triggerOnce={true}
        onChange={(inView) => {
          inView && trackEvent(impression({ impressionElement: ImpressionElement.Project }));
        }}
      >
        <Header isSEOBot={isSEOBot} project={project} tier={tier} />
        {isSEOBot ? (
          <SEOContent activeCategories={activeCategories} data={data} />
        ) : tier === 'pro' ? (
          <span id="no-paywall"></span>
        ) : (
          <Paywall paywallData={paywallData} leadType={project.leadType} />
        )}
      </InView>
    </Track>
  );
};

export default Layout;
